import React, { useRef } from 'react';
import { usePropertyContext } from '../../contexts/DecisionMaking/PropertyContext';
import { useAvmContext } from '../../contexts/DecisionMaking/AvmContext';
import PropertySummary from './PropertySummary';
import ImagesMapContainer from '../common/ImagesMapContainer';
import { useListSortContext } from '../../contexts/DecisionMaking/ListSortContext';
import { GalleriaRefContext } from '../../contexts/GalleriaRefContext';

const DecisionMakingPropertyContainer = () => {
  const galleriaRef = useRef(null);

  const {
    propertyId,
    propertyDetails,
    isLoadingPropertyDetails,
    mlsPropertyImages,
  } = usePropertyContext();

  const { errorMostRecentAvmResults, avmCompsForMap } = useAvmContext();

  const { activeListSort } = useListSortContext();

  return (
    <div id="decision-making-property-container" className="w-full h-full">
      <div
        id="dm-property-container-property-summary-container"
        className="rounded-xl shadow-2xl"
      >
        <PropertySummary
          propertyData={propertyDetails}
          listSort={activeListSort}
          loading={isLoadingPropertyDetails}
        />
      </div>
      <div
        id="dm-property-container-images-map-container"
        className="rounded-xl shadow-2xl"
      >
        <div id="images-map-container" className="w-full">
          <GalleriaRefContext.Provider value={galleriaRef}>
            <ImagesMapContainer
              property={propertyDetails}
              avmCompsForMap={avmCompsForMap}
              mlsPropertyImages={mlsPropertyImages}
              propertyId={propertyId}
              isLoading={isLoadingPropertyDetails}
              error={errorMostRecentAvmResults?.message}
            />
          </GalleriaRefContext.Provider>
        </div>
      </div>
    </div>
  );
};

export default DecisionMakingPropertyContainer;
